import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { Divider, Form, Header } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { ClimaRegDataType } from '~/api/services/climaProgram'
import { formatNumber } from '~/utils/helpers'
import ErrorIcon from '~/components/ErrorIcon'

interface Props {
  milkOptions: ClimaRegDataType['milkAmounts']
  concentratedFeedsAmounts: ClimaRegDataType['concentratedFeedsAmounts']
}

const BasicFields: React.FC<Props> = ({ milkOptions, concentratedFeedsAmounts }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <>
      <Header as='h4'>{t('Basic Information')}</Header>
      <Divider />
      <Form.Group widths='equal' style={{ alignItems: 'end' }}>
        <FormFields.Input
          name='cowsNumber'
          withoutAsterisk
          control={control}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('What is the maximum number of dairy cows you have on your farm (number of stalls for lactating and dry cows)?')}
            <ErrorIcon control={control} name='cowsNumber' />
          </div>}
          typeInput='controled'
          allowDecimals={false}
          noErrorMessage
          rules={{
            required: true,
            min: {
              value: 0,
              message: t('Value must be at least 0')
            }
          }}
        />
        <FormFields.Select
          name='avgMilkAmount'
          search
          control={control}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('What is the average milk yield per cow per year on your farm?')}
            <ErrorIcon control={control} name='avgMilkAmount' />
          </div>}
          options={milkOptions?.map(option => ({ text: `${formatNumber(option.key, 0)} kg`, value: option.value }))}
          withoutAsterisk
          placeholder={t('Select')}
          noErrorMessage
          rules={{
            required: true
          }}
        />

        <FormFields.Select
          name='yearlyConcentratedFeedAmountPerCow'
          control={control}
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            {t('Yearly concentrated feed amount per cow (kg)')}
            <ErrorIcon control={control} name='yearlyConcentratedFeedAmountPerCow' />
          </div>}
          options={concentratedFeedsAmounts?.map(option => ({ text: `${formatNumber(option.key, 0)} kg`, value: option.value }))}
          withoutAsterisk
          noErrorMessage
          placeholder={t('Select')}
          rules={{
            required: true
          }}
        />
      </Form.Group>
    </>
  )
}

export default BasicFields
